import { render, staticRenderFns } from "./patient-row.vue?vue&type=template&id=65ec6e40&scoped=true"
import script from "./patient-row.vue?vue&type=script&lang=js"
export * from "./patient-row.vue?vue&type=script&lang=js"
import style0 from "./patient-row.vue?vue&type=style&index=0&id=65ec6e40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ec6e40",
  null
  
)

export default component.exports